/**
 * Invoice Generator Page
 * Wrapper page for the InvoiceGenerator component
 */

import { useParams, useNavigate } from 'react-router-dom';
import { InvoiceGenerator as InvoiceGeneratorComponent } from '../components/invoice/InvoiceGenerator';

export const InvoiceGenerator = () => {
  const { jobId } = useParams<{ jobId: string }>();
  const navigate = useNavigate();

  if (!jobId) {
    return (
      <div className="card text-center py-12">
        <h2 className="text-2xl font-bold text-neutral-900 mb-2">Invalid Job</h2>
        <p className="text-neutral-600 mb-6">Job ID is required to generate an invoice</p>
        <button onClick={() => navigate('/')} className="btn-primary">
          Go Home
        </button>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <InvoiceGeneratorComponent
        jobId={jobId}
        onInvoiceGenerated={() => {
          navigate(`/jobs/${jobId}`, {
            state: { activeTab: 'invoices' }
          });
        }}
      />
    </div>
  );
};
